module.exports = __webpack_public_path__ + "fonts/834d6dd64ceeb95eac0822d67bb4db46.svg";